import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "clear",
  "use": "clear-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"clear\"><path fill-rule=\"evenodd\" d=\"M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm4.35-3.35c.2.2.2.52 0 .7-.2.2-.5.2-.7 0l-3.4-3.4-3.4 3.4c-.2.2-.52.2-.7 0-.2-.18-.2-.5 0-.7l3.4-3.4-3.4-3.4c-.2-.2-.2-.5 0-.7.18-.2.5-.2.7 0l3.4 3.4 3.4-3.4c.2-.2.5-.2.7 0 .2.2.2.5 0 .7l-3.4 3.4 3.4 3.4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol